import i18n from "plugins/localization";
import { Platform } from "react-native";
import { navigationRef } from "../RootNavigation";
import toast from "./toast";

export default (error: any, params: any = {}) => {
  // console.error(JSON.stringify(error, null, 4));

  const routeName =
    (navigationRef.current && navigationRef.current.getCurrentRoute()?.name) ||
    "CATCHALL";
  // console.log(routeName);

  const code = error.response?.data?.code;

  if (!code) {
    toast.error(i18n.t("errors.CATCHALL"));
    return;
  }

  let errorMessage = i18n.t(`errors.screens.${routeName}.${code}`, params);

  if (!errorMessage.includes("error")) {
    // error message found in the en.ts file
    toast.error(errorMessage);
    return;
  }

  // See if error message found in global error
  errorMessage = i18n.t(`errors.GLOBAL.${code}`);

  if (errorMessage.includes("error")) {
    // if error message not found, try the error message from the server
    const serverErrorMsg = error.response?.data?.message;
    errorMessage = serverErrorMsg ? serverErrorMsg : i18n.t(`errors.CATCHALL`);
  }

  handleGlobalHTTPError(code, errorMessage);
};

const handleGlobalHTTPError = async (code: string, errorMessage: string) => {
  const routeName = navigationRef.current?.getCurrentRoute()?.name;
  if (!routeName) return;

  switch (code) {
    case "SESSION_EXPIRED": {
      navigationRef.navigate("AuthenticatedFlow", { screen: "LogOut" });
      toast.error("Your user session has expired, please login");
      break;
    }
    case "ACCOUNT_NOT_FOUND": {
      // if in these pages we get ACCOUNT_NOT_FOUND, we should not redirect to AccountSetup
      const excluedRouted = ["ClaimSeats", "ClaimGuestPasses"];
      const currentRoute = navigationRef.current?.getCurrentRoute();
      if (Platform.OS === "web") {
        if (excluedRouted.includes(currentRoute?.name!)) {
          return;
        }
        navigationRef.navigate("AuthenticatedFlow", { screen: "AccountSetup" });
        toast.error(
          "We couldn't find a valid membership on this account. Please purchase a membership."
        );
      }
      break;
    }
    default:
      toast.error(errorMessage);
  }
};
